// Dawn-style <cart-drawer> adapted for Concocina markup (no modules)
(function () {
  const utils = window.themeCartUtils || {};
  const trapFocus = utils.trapFocus || function () {};
  const removeTrapFocus = utils.removeTrapFocus || function () {};

  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.main = document.querySelector('main');
      this.drawer = document.getElementById('cart-drawer');
      this.overlay = document.getElementById('cart-drawer-overlay');

      this.handleClick = (event) => {
        const trigger = event.target.closest('[data-cart-drawer-trigger]');
        if (trigger) {
          this.open();
          return;
        }
        const close = event.target.closest('[data-cart-drawer-close]');
        if (close) {
          this.close();
        }
      };

      this.bindEvents();
    }

    bindEvents() {
      document.addEventListener('click', this.handleClick);
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }
      if (this.drawer) {
        this.drawer.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close();
        });
      }
    }

    open() {
      this.drawer = document.getElementById('cart-drawer');
      this.overlay = document.getElementById('cart-drawer-overlay');
      if (!this.drawer || !this.overlay) return;
      this.overlay.setAttribute('aria-hidden', 'false');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      trapFocus(this.drawer, this.drawer.querySelector('.cart-drawer__close'));
    }

    close() {
      this.drawer = document.getElementById('cart-drawer');
      this.overlay = document.getElementById('cart-drawer-overlay');
      if (!this.drawer || !this.overlay) return;
      this.overlay.setAttribute('aria-hidden', 'true');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      removeTrapFocus(this.drawer);
    }

    getSectionsToRender() {
      return [
        {
          section: 'cart-drawer',
          selector: '#cart-drawer'
        },
        {
          section: 'cart-icon-bubble',
          selector: '.cart-icon-bubble'
        }
      ];
    }

    renderContents(parsedState) {
      if (!parsedState || !parsedState.sections) return;
      this.getSectionsToRender().forEach(({ section, selector }) => {
        const container = document.querySelector(selector);
        const html = parsedState.sections[section];
        if (!container || !html) return;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const replacement =
          tempDiv.querySelector(selector) || tempDiv.firstElementChild;
        if (replacement) {
          container.replaceWith(replacement);
        } else {
          container.innerHTML = html;
        }
      });
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }
})();

